import axios from 'axios';

// In production (Azure), use empty string to use same origin as the app
// In development, use environment variable or default to localhost:5000
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? (process.env.REACT_APP_API_URL || '') 
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Public API
export const couponApi = {
  // Get all active coupons (with optional filters)
  getCoupons: (params) => api.get('/api/coupons', { params }),
};

// Admin API
export const adminApi = {
  // Login
  login: (credentials) => api.post('/api/admin/login', credentials),
  
  // Get all coupons (including expired)
  getAllCoupons: () => api.get('/api/admin/coupons'),
  
  // Create coupon
  createCoupon: (couponData) => api.post('/api/admin/coupons', couponData),
  
  // Update coupon
  updateCoupon: (id, couponData) => api.put(`/api/admin/coupons/${id}`, couponData),
  
  // Delete coupon
  deleteCoupon: (id) => api.delete(`/api/admin/coupons/${id}`)
};

export default api;
